import React from 'react';
import TwoColumns from '../../components/shared/TwoColumns';
import MeasurementSummaryImage from './MeasurementSummaryImage';
import MeasurementSummaryList from './MeasurementSummaryList';

const TwoColumnMeasurementSummary = () => (
  <TwoColumns
    col1={<MeasurementSummaryImage />}
    col2={<MeasurementSummaryList />}
  />
);
export default TwoColumnMeasurementSummary;
